import React from "react";
import { Sparkles } from "lucide-react";
import { useT } from "@/lib/LanguageContext";

/**
 * DraftBadge — marqueur de responsabilité IA.
 * Toute sortie générée par l'IA et susceptible d'atteindre un client doit
 * être visiblement étiquetée "Brouillon IA — à valider" jusqu'à approbation
 * explicite par un humain.
 */
export const DraftBadge = ({ label, className = "" }) => {
  // Réutilise "insights.draft" (namespace admin, déjà traduit 3 langues) : les
  // deux seuls consommateurs (AiInsightsCard, PostEditorModal) vivent sous admin/.
  const t = useT("admin");
  return (
    <span
      data-testid="ai-draft-badge"
      className={`inline-flex items-center gap-1 rounded-full bg-amber-100 text-amber-900 border border-amber-300 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${className}`}
    >
      <Sparkles className="w-3 h-3" /> {label || t("insights.draft")}
    </span>
  );
};

export default DraftBadge;
